import { clientApiCall } from "./apiCallWrapper";

const withCredentials = { withCredentials: true };

/**
 * Клиентский (браузерный) API корзины Bitrix bxApi (/basket/*).
 */
export default (_axios: any, config: any) => ({
  getBasket(cookie?: string) {
    return clientApiCall(`${config.API_URL}/basket/getBasket`, {
      api: "basket.getBasket",
      method: "post",
      params: {},
      skipForRobots: true,
      axiosConfig: {
        ...withCredentials,
        ...(cookie ? { headers: { cookie } } : {}),
      },
    });
  },
  addProductToBasket(id: string, price: any = false) {
    return clientApiCall(
      `${config.API_URL}/basket/addToBasket?id=${id}&price=${price}`,
      {
        api: "basket.addProductToBasket",
        critical: true,
        method: "post",
        params: {},
        axiosConfig: withCredentials,
      },
    );
  },
  addToBasketInstall(id: string, installPrice: any = false) {
    return clientApiCall(
      `${config.API_URL}/basket/addToBasket?id=${id}&installPrice=${installPrice}`,
      {
        api: "basket.addToBasketInstall",
        critical: true,
        method: "post",
        params: {},
        axiosConfig: withCredentials,
      },
    );
  },
  removeFromBasket(id: string) {
    return clientApiCall(`${config.API_URL}/basket/removeFromBasket?id=${id}`, {
      api: "basket.removeFromBasket",
      critical: true,
      method: "post",
      params: {},
      axiosConfig: withCredentials,
    });
  },
  changeBasketQty({ id, qty }: { id: string; qty: number }) {
    return clientApiCall(
      `${config.API_URL}/basket/changeBasketQty?id=${id}&qty=${qty}`,
      {
        api: "basket.changeBasketQty",
        critical: true,
        method: "post",
        params: {},
        axiosConfig: withCredentials,
      },
    );
  },
});
